import React from "react";
import { useNavigate } from "react-router-dom";

const Careers = () => {
  const navigate = useNavigate();

  const handleApply = (e) => {
    e.preventDefault();
    navigate("/contact");
  };
  const jobs = [
    { id: 1, title: "Front-End Developer", type: "Full-Time", icon: "💻", description: "Build responsive and high-performance web interfaces using React and modern JS frameworks." },
    { id: 2, title: "UI/UX Designer", type: "Part-Time", icon: "🎨", description: "Design user-centered experiences, wireframes, and prototypes for web & mobile apps." },
    { id: 3, title: "Backend Developer", type: "Remote", icon: "🖥️", description: "Develop scalable server-side applications with Node.js, Express, and databases." },
    { id: 4, title: "Mobile App Developer", type: "Full-Time", icon: "📱", description: "Build cross-platform mobile applications using Flutter and React Native." },
    { id: 5, title: "Digital Marketing Specialist", type: "Full-Time", icon: "📈", description: "Create SEO, social media, and PPC campaigns to drive business growth." },
    { id: 6, title: "Business Development Manager", type: "Remote", icon: "🚀", description: "Drive client acquisition, partnerships, and revenue growth through innovative strategies." },
  ];

  return (
    <section id="careers" className="min-h-screen bg-gray-50 px-6 py-20">
      {/* Heading */}
      <div className="text-center mb-16 max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-blue-600 mb-4">
          Careers
        </h2>
        <p className="text-gray-700 text-lg md:text-xl">
          Join our team and help us build amazing digital experiences. Check out our open positions below and apply to start your journey with NEXWYS.
        </p>
      </div>

      {/* Jobs Grid */}
      <div className="max-w-5xl mx-auto grid gap-8 sm:grid-cols-2 md:grid-cols-3">
        {jobs.map((job) => (
          <div
            key={job.id}
            className="relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 group overflow-hidden text-center flex flex-col justify-between h-[380px]"
          >
            {/* Animated Gradient Background */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 pointer-events-none opacity-0 group-hover:opacity-10 transition duration-500 rounded-3xl"></div>

            <div>
              {/* Job Icon */}
              <div className="text-5xl mb-4 animate-bounce">{job.icon}</div>

              {/* Job Title */}
              <h3 className="text-xl font-semibold text-gray-900 mb-1">{job.title}</h3>

              {/* Job Type */}
              <p className="text-blue-600 font-medium mb-3">{job.type}</p>

              {/* Short Description */}
              <p className="text-gray-600 text-sm mb-6 leading-relaxed">{job.description}</p>
            </div>

            {/* Apply Button */}
            <div>
              <button
                onClick={handleApply}
                className="bg-blue-600 text-sm text-white px-6 py-2 rounded-full font-semibold shadow-md hover:bg-blue-700 transition-colors duration-300"
              >
                Apply Now
              </button>

              {/* Bottom Accent Line */}
              <div className="mt-6 mx-auto h-1 w-0 bg-blue-600 group-hover:w-16 transition-all duration-300 rounded-full"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Careers;